<div class="toolbar text-default w-full px-6 flex items-center">
  <button (click)="openSidenav()" [class.hidden]="isDesktop$ | async" mat-icon-button type="button">
    <mat-icon svgIcon="mat:menu"></mat-icon>
  </button>

  <!-- A long organization name is cut with an ellipsis instead of pushing the toolbar wider than a phone -->
  <a [routerLink]="['/']" class="ltr:mr-4 rtl:ml-4 flex items-center min-w-0">
    <h1 class="font-medium truncate">{{securityService.securityObject.orgName}}</h1>
  </a>

  <span class="flex-1"></span>
</div>
